import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import './MultipleQuestionItem.css';
import { alphabet } from '../../../static/utils';

const MultipleQuestionItem = ({ question, onMultipleClick, index, activeTabPosts, isReview, showCarousel }) => {
    const [isChecked, setChecked] = useState(false);

    const handleChange = useCallback(() => {
        onMultipleClick(question, false);
        setChecked(!isChecked);
    }, [question, isChecked, onMultipleClick]);

    return (
        <label
            className={classNames('multiple-question-item mb-2 ', {
                'justify-content-start': showCarousel,
                active: isChecked,
            })}
        >
            <div className="letter mr-3">{alphabet[question.order]}</div>
            <input type="checkbox" id={index} onChange={handleChange} />
            <div className={classNames({
                'title': showCarousel,
                'title-small': !showCarousel
            })}>{question.title}</div>
        </label>
    );
};

export default MultipleQuestionItem;
